<template>
<div class="app-main">
  <main>
      <router-view />
  </main>
</div>

</template>

<script>
export default {
}
</script>

<style lang='scss'>
@import "@/assets/scss/style.scss";
</style>
